import React, { useCallback, useEffect, useState } from 'react';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import useAuthContext from '../../hooks/useAuthContext';
import { useNavigate } from 'react-router-dom';
import { useGenerateResponseForNimbus } from '../../hooks/useGenerate';
import { message } from 'antd';
import { updateStepWiseUserData } from '../../redux/Reducers/userStepsDataDetailReducer';
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import useCreditContext from '../../hooks/useCreditContext';
import 'react-multi-email/dist/style.css';
import miscApi from '../../apis/misc';
import DynamicModal from '../../common/DynamicModal/DynamicModal';



const EmailModal = ({
  availableCredits,
  creditsRequired,
  handleGenerateBtn
}) => {
  const {
    stepUploadImages: { files: uploaded_files },

  } = useSelector((state) => state.userStepsDataDetailReducer);


  const {
    user: { userEmail, userToken },
    isAuthenticated,
  } = useAuthContext();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emails, setEmails] = useState([]);

  useEffect(() => {
    const userEmail = JSON.parse(localStorage.getItem('mm:user')).userEmail;
    setEmails([userEmail]);
  }, [localStorage.getItem('mm:user')])


  

  const handleSubmit = () => {
    handleGenerateBtn(availableCredits, creditsRequired);
    navigate('/dashboard');
  }

  return (
    <div>
   
        <div className="email_modal_popup">
          <div className="email_box">
            <label>Your Email:</label>
            <ReactMultiEmail
              placeholder="Enter emails"
              emails={emails}
              onChange={setEmails}
              validateEmail={(email) => isEmail(email)}
              getLabel={(email, index, removeEmail) => (
                <div key={index}>
                  {email}
                  <span onClick={() => removeEmail(index)}>×</span>
                </div>
              )}
            />
            <button onClick={handleSubmit}>Submit</button>
          </div>
        </div>
     
    </div>
  )
}

export default EmailModal;